/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import * as authActions from "../../../store/auth/actions";
import * as uiActions from "../../../store/ui/actions";
import * as userActions from "../../../store/user/actions";
import * as companyActions from "../../../store/company/actions";
import * as userselectors from "../../../store/user/selector";
import * as authSelectors from "../../../store/auth/selectors";
import * as uiSelectors from "../../../store/ui/selector";
import * as companySelectors from "../../../store/company/selector";
import * as notActions from "../../../store/notification/actions";
import Header from "../../../app/common/Header/Header";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from "axios";
import { Redirect, withRouter } from "react-router-dom";
import { routes } from "../../utilities/routes";
import {
  SUPER_ADMIN_ROLE,
  INCORRECT_TOKEN,
  INVALID_USER,
  ACCESS_DENIED,
  INVALID_TOKEN,
  USER_AUTH_SUCCESS,
  TOKEN_EXPIRED,
  REFRESH_TOKEN_EXPIRED,
  LOGOUT_SUCCESS,
} from "../../../constants/Constants";
import ModalPortal from "../ModalPortal";
import SystemFailure from "../SystemFailure";
import DatabaseFailure from "../DatabaseFailure";
import TooManyRequestError from "../TooManyRequestError";
import { RequestRefreshToken } from "../../../store/auth/services";
import {
  BILLING_ADMIN,
  CUSTOMER_ADMIN,
  USER_ROLE,
} from "../../../app/Constants/Constants";
import Loader from "../Loader";
import { clearSessionDetails } from "../../../app/Utilities/utils";

class HeaderContainer extends React.Component {
  constructor() {
    super();
    this.logout = this.logout.bind(this);
    this.setRequestToken = this.setRequestToken.bind(this);
    this.selectCompany = this.selectCompany.bind(this);
    this.setActiveHeader = this.setActiveHeader.bind(this);
    this.closePortalError = this.closePortalError.bind(this);
    this.closeDatabaseError = this.closeDatabaseError.bind(this);
    this.closeTooManyRequestError = this.closeTooManyRequestError.bind(this);
    this.initLogout = false;
    this.setAxiosResponseInterceptor =
      this.setAxiosResponseInterceptor.bind(this);
    this.state = {
      portalError: false,
      databaseError: false,
      error429: false,
    };
    this.setAxiosResponseInterceptor();
    this.switchCompanyDetails = React.createRef();
  }
  setAxiosResponseInterceptor() {
    axios.interceptors.response.use(
      /* istanbul ignore next */
      (response) => {
        if (
          (response && response.data.message === USER_AUTH_SUCCESS) ||
          (response && response.data.message === LOGOUT_SUCCESS)
        ) {
          this.setState({ userAuthSuccess: true });
        }
        return response;
      },
      /* istanbul ignore next */
      async (error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message === ACCESS_DENIED &&
          error.response.status === 403
        ) {
          this.setState({
            portalError: false,
            databaseError: false,
            error429: false,
          });
          this.logout();
        }
        const isWhitelisted = this.checkIfErrorWhitelisted(error.config.url);
        if (error.message.includes("Network Error") && !isWhitelisted) {
          this.setState({
            portalError: true,
          });
        }
        if (error.response && error.response.status === 500 && !isWhitelisted) {
          this.setState({
            databaseError: true,
          });
        }
        if (error.response && error.response.status === 429 && !isWhitelisted) {
          this.setState({
            error429: true,
          });
        }
        if (
          error.response &&
          error.response.data &&
          error.response.data.message === INCORRECT_TOKEN &&
          error.response.status === 401
        ) {
          this.setState({
            portalError: false,
            databaseError: false,
            error429: false,
          });
          this.logout();
        }
        if (
          error.response &&
          error.response.data &&
          error.response.data.message === INVALID_USER &&
          error.response.status === 401
        ) {
          this.setState({
            portalError: false,
            databaseError: false,
            error429: false,
          });
          this.logout();
        }
        if (
          error.response &&
          error.response.data &&
          error.response.data.message === INVALID_TOKEN &&
          error.response.status === 401
        ) {
          this.setState({
            portalError: false,
            databaseError: false,
            error429: false,
          });
          this.logout();
        }
        if (
          error.response &&
          error.response.data &&
          error.response.data.message === TOKEN_EXPIRED &&
          error.response.status === 401
        ) {
          await RequestRefreshToken();
          return axios(error.config);
        }
        if (
          error.response &&
          error.response.data &&
          error.response.data.message === REFRESH_TOKEN_EXPIRED &&
          error.response.status === 401
        ) {
          this.setState({
            portalError: false,
            databaseError: false,
            error429: false,
          });
          this.logout();
        }
        return Promise.reject(error);
      },
    );
    axios.interceptors.request.use(
      /* istanbul ignore next */
      (config) => {
        let obj = {};
        const isDarkSide = process.env.REACT_APP_DARK;
        /* istanbul ignore if */
        if (isDarkSide && isDarkSide !== "") {
          const name = isDarkSide && isDarkSide.split("=")[0];
          const value = isDarkSide && isDarkSide.split("=")[1];
          obj[name] = value;
          config.params = { ...config.params, ...obj };
        }
        return config;
      },
      /* istanbul ignore next */
      (error) => {
        return Promise.reject(error);
      },
    );
  }
  /* istanbul ignore next */
  checkIfErrorWhitelisted(url) {
    const whitelistedUrls = ["adminNotification"];
    let isWhitelisted = false;
    whitelistedUrls.forEach((eachUrl) => {
      if (url.indexOf(eachUrl) !== -1) {
        isWhitelisted = true;
      }
    });
    return isWhitelisted;
  }
  /* istanbul ignore next */
  closePortalError() {
    this.setState({
      portalError: false,
    });
  }
  /* istanbul ignore next */
  closeDatabaseError() {
    this.setState({
      databaseError: false,
    });
  }
  /* istanbul ignore next */
  closeTooManyRequestError() {
    this.setState({
      error429: false,
    });
  }
  /* istanbul ignore next */
  componentDidMount() {
    this.props.CheckAuth();
  }
  /* istanbul ignore next */
  componentDidUpdate(prevProps) {
    if (
      prevProps.auth &&
      this.props.auth &&
      this.props.auth.user?.user_id !== prevProps.auth.user?.user_id
    ) {
      if (this.props.auth.user?.user_id) {
        this.props.FetchAllCompanies();
      }
      if (!this.state.userAuthSuccess) {
        this.props.FetchAUser();
      }
      if (this.props.auth.user) {
        let defaultComapny = localStorage.getItem("default_company");
        defaultComapny = defaultComapny ? JSON.parse(defaultComapny) : false;
        defaultComapny = defaultComapny
          ? defaultComapny
          : defaultComapny === null
          ? null
          : {
              companyuuid: this.props.auth.user.companyuuid,
              company_name: this.props.auth.user.companyname,
              companyType: this.props.auth.user.customerAccountType,
            };
        this.props.SetDefaultCompany(defaultComapny);
      }
    }
    if (
      this.props?.switchCompanyResponse !== null &&
      this.props?.switchCompanyResponse?.success !==
        prevProps?.switchCompanyResponse?.success
    ) {
      clearSessionDetails();
      this.switchDefaultCompany(this.switchCompanyDetails.current);
    }
  }
  /* istanbul ignore next */
  setActiveHeader(item) {
    this.props.SetActiveHeader(item);
  }

  /* istanbul ignore next */
  starCompanyHandler = (list) => {
    this.props.StarCompany(list);
  };

  /* istanbul ignore next */
  unStarCompanyHandler = (id) => {
    this.props.UnStarCompany(id);
  };

  /* istanbul ignore next */
  setRequestToken() {
    axios.defaults.withCredentials = true;
  }
  /* istanbul ignore next */
  handleWSData() {
    if (this.props.auth && this.props.auth.user) {
      this.props.FetchPendingUserNotif(
        this.props.auth.user.compnayuuid,
        this.props.auth.user.user_id,
      );
    }
  }
  /* istanbul ignore next */
  logout() {
    this.initLogout = true;
    this.props.history.push(routes.logout);
  }

  /* istanbul ignore next */
  switchDefaultCompany = (company) => {
    this.props.history.push({
      pathname: routes.dashboard,
      state: { companySwitch: true },
    });
    this.props.SetDefaultCompany(company);
  };
  /* istanbul ignore next */
  selectCompany(company) {
    this.props.SwitchCompany(company?.companyuuid);
    this.switchCompanyDetails.current = company;
  }

  render() {
    const initLogout = this.initLogout;
    this.initLogout = false;
    this.setRequestToken();
    return this.props.auth.isLoggedIn &&
      !this.props.auth.reset_password_response ? (
      <div>
        {this.state.portalError ||
        this.state.databaseError ||
        this.state.error429 ? null : (
          <Header
            auth={this.props.auth}
            starCompanyHandler={this.starCompanyHandler}
            unStarCompanyHandler={this.unStarCompanyHandler}
            logoutHandler={this.logout}
            companyList={this.props.companyList}
            favoriteCompanies={this.props.favoriteCompanies}
            defaultCompany={this.props.defaultCompany}
            selectCompany={this.selectCompany}
            activeHeader={this.props.activeHeader}
            setActiveHeader={this.setActiveHeader}
            currentUser={this.props.currentUser}
          />
        )}
        {this.props?.switchCompanyLoadingStatus?.loading &&
          !this.props?.switchCompanyLoadingStatus?.loaded && <Loader />}
        {this.state.portalError && (
          <ModalPortal>
            <SystemFailure close={this.closePortalError} />
          </ModalPortal>
        )}
        {this.state.databaseError && (
          <ModalPortal>
            <DatabaseFailure close={this.closeDatabaseError} />
          </ModalPortal>
        )}
        {this.state.error429 && (
          <ModalPortal>
            <TooManyRequestError />
          </ModalPortal>
        )}
      </div>
    ) : initLogout ? (
      <Redirect
        to={{
          pathname:
            process.env.REACT_APP_ENABLE_SSO === "true"
              ? routes.signin
              : routes.login,
        }}
      />
    ) : (
      ""
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    auth: authSelectors.getauth(state),
    companyList: companySelectors.allCompanies(state),
    favoriteCompanies: companySelectors.getCompanyFavorites(state),
    defaultCompany: companySelectors.getDefaultCompany(state),
    activeHeader: uiSelectors.getActiveHeader(state),
    currentUser: userselectors.getCurrentUser(state),
    userLoaded: userselectors.getUsersLoadingStatus(state),
    switchCompanyResponse: companySelectors.getSwitchCompany(state),
    switchCompanyLoadingStatus:
      companySelectors.getSwitchCompanyLoadingStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...authActions,
      ...companyActions,
      ...uiActions,
      ...notActions,
      ...userActions,
    },
    dispatch,
  );
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HeaderContainer),
);
